import { environment } from 'src/environments/environment';

export class ApiCommonHandler {
  constructor() {}

  protected getAPIFullUrlByName(name: string) {
    return environment.base_url + name;
  }

  protected getAdminAPIFullUrlByName(name: string) {
    return environment.admin_api_url + name;
  }
}
